import { action } from 'mobx';
import { API, APIPaginatedResponse } from '../types';
import {withIncludesAndPage} from '../../../lib/api';
import {TrackSchema} from '../../../types/schema';

export class ReleaseAPIController extends API {
  @action
  getReleaseTracks = async (slug: string, includes: string[] = ['images', 'artists', 'audio'], page: number = 1) => {
    const url = `/catalog/release/${slug}/tracks${withIncludesAndPage(includes, page)}`;
    const resp = await this.request.get({ url });
    const json = await resp.json() as APIPaginatedResponse<Array<TrackSchema>>;

    this.cache.addTracks(json.data);

    return json;
  }
}